/**
 * Vue iframe-resizer
 * http://davidjbradshaw.github.io/iframe-resizer/
 */
import { iframeResize } from 'iframe-resizer';

export const plugin = {
    name: 'iframe-resizer',

    install (Vue) {
        Vue.directive('resize', {
            bind: function (el, { value = {} }) {
                // console.info("bind iframe-resizer to ", el);
                el && el.addEventListener('load', () => iframeResize(value, el));
            },
            unbind: function (el) {
                // console.info("unbind iframe-resizer from ", el);
                el && el.iFrameResizer && el.iFrameResizer.removeListeners();
            }
        });
    }
};

export default plugin;
